import { DependencyList, useMemo } from 'react';

export const useDeepCompareMemo = <T>(factory: () => T, deps: DependencyList | undefined) => {
  //  eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(factory, [JSON.stringify(deps)]);
};
